<template>
  <div class="fill-height d-flex flex-column align-content-stretch">
    <div class="flex-grow-1 overflow-auto px-4">
      <v-row
        v-if="records.length <= 0"
        class="mt-2"
      >
        <v-col class="text-center grey--text">
          <v-icon
            size="60"
            color="grey"
            >mdi-video-outline</v-icon
          >
          <div class="text-info mt-2">{{ $t("messages.information.no_record") }}</div>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col class="pa-0">
          <v-sheet v-if="isLoading">
            <v-skeleton-loader
              max-width="300"
              type="list-item-avatar"
            ></v-skeleton-loader>
          </v-sheet>

          <v-list
            dense
            flat
            v-else
          >
            <v-list-item
              v-for="item in records"
              :key="item.sid"
              @click="downloadRecord(item.sid)"
            >
              <v-list-item-content>
                <v-list-item-title v-html="item.date_created"></v-list-item-title>
                <v-list-item-subtitle v-html="recordDuration(item.duration)"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                <v-btn
                  class="blue white--text"
                  icon
                  @click="
                    currentRecordSid = item.sid
                    deleteDialog = true
                  "
                >
                  <v-icon> mdi-delete </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-dialog
        v-model="deleteDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="headline">
            {{ $t("actions.delete", { entity: $t("commons.record").toLowerCase() }) }}
          </v-card-title>

          <v-card-text>
            {{
              $t("messages.information.delete_entity", {
                type: $t("commons.record").toLowerCase(),
                entity: ""
              })
            }}<br />
            {{ $t("messages.information.delete_capture.prevention") }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="deleteDialog = false"
            >
              {{ $t("commons.cancel") }}
            </v-btn>
            <v-btn
              color="error"
              @click="deleteRecord"
            >
              {{ $t("actions.delete", { entity: "" }) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="pt-2 pr-2">
      <v-btn
        block
        class="blue white--text"
        @click="getRecords"
      >
        <v-icon left>mdi-cached</v-icon>
        Refresh
      </v-btn>
    </div>
  </div>
</template>

<script>
import { MeetingService } from "@/services"
export default {
  name: "Recording",
  props: {
    inspection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLoading: true,
      isRecording: false,
      records: [],
      dialog: false,
      hover: false,
      deleteDialog: false,
      currentRecordSid: null
    }
  },
  created() {},
  mounted() {
    this.getRecords()
  },
  methods: {
    recordDuration(value) {
      return value + " sec"
    },
    downloadRecord(sid) {
      // this.isLoading = true
      MeetingService.downloadRecord(this, this.inspection.id, sid)
        .then(link => {
          //Todo
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    deleteRecord() {
      let t = this

      MeetingService.removeRecord(this, this.inspection.id, this.currentRecordSid)
        .then(r => {
          t.$store.commit("app/message", {
            msg: "Record deleted",
            color: "success"
          })
          //Reload records list
          this.getRecords()
        })
        .finally(() => {
          t.deleteDialog = false
        })
    },
    getRecords() {
      this.isLoading = true
      MeetingService.getRecordings(this, this.inspection.id)
        .then(r => {
          this.records = r
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
